import * as React from 'react';
import { type HTMLProps } from 'react';
// @ts-ignore
import { type Element } from 'hast';
import { ImageWithModal } from '../ImageWithModal';
import { styled } from '../../theme/theme';
import { ChatConst } from './ChatConst';

type TMessageTypeMarkdownImageProps = HTMLProps<HTMLImageElement> & {
  node: Element;
};

export const MessageTypeMarkdownImage = ({ node, ...otherProps }: TMessageTypeMarkdownImageProps) => {
  return (
    // @ts-ignore
    <Image {...otherProps} />
  );
};

const Image = styled(ImageWithModal)`
  ${ChatConst.messageContentMediaParams};
  margin-top: 24px;
`;
